import { Trans, useTranslation } from "react-i18next";

// Tags allowed inside site.json strings, e.g. "Meet with intention.<br/><em>Marry with confidence.</em>"
const RICH_TAGS = { em: <em />, br: <br />, strong: <strong /> };

/** Translation hook for the public site's "site" namespace, plus the current direction. */
export function useSiteTranslation() {
  const { t, i18n } = useTranslation("site");
  const language = i18n.language === "ar" ? "ar" : "en";
  return { t, i18n, language, dir: language === "ar" ? "rtl" : "ltr" };
}

/** Renders a site.json string that contains <em>, <br/> or <strong> tags. */
export function RichText({ k, values }) {
  const { t } = useTranslation("site");
  return <Trans t={t} i18nKey={k} values={values} components={RICH_TAGS} />;
}
